import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	fetchWorkshopPayment, updateWorkshopPayment, cancelSession, restoreCancelledSession,
	cancelAllSessions, cancelAndRefundSession, cancelAndRefundAllSessions, sendInvoice, rescheduleSession
} from './actions';
import {
	markAsPaid, markAsCancelled, applyPromoCode, retryInstalment,
	PAYMENT_HISTORY_MARK_AS_PAID_REQUEST, PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS, PAYMENT_HISTORY_MARK_AS_PAID_FAILURE,
	PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST, PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE,
	PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST, PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS, PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE,
	PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST, PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS, PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE
} from '../paymentHistory/actions';
import {
	markAsPaidInstalment,
	INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST, INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE
} from '../instalmentPayments/actions';
import MarkAsPaidInstalmentDialog from '../paymentHistory/MarkAsPaidInstalmentDialog';
import { loadWorkshopSessions } from '../workshops/actions';
import WorkshopPaymentSettingsForm from './SettingsForm';
import MarkAsPaidDialog from '../paymentHistory/MarkAsPaidDialog';
import MarkAsCancelledDialog from '../paymentHistory/MarkAsCancelledDialog';
import { selector as promoCodeFormSelector } from '../paymentHistory/PromoCodeForm';
import PromoCodeDialog from '../paymentHistory/PromoCodeDialog';
import RefundDialog from '../enrolments/RefundDialog';
import RescheduleDialog from './RescheduleDialog';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleWorkshopPaymentSettingsSubmit = this.handleWorkshopPaymentSettingsSubmit.bind(this);
		this.handleMarkAsCancelledDialogConfirm = this.handleMarkAsCancelledDialogConfirm.bind(this);
		this.showMarkAsCancelledDialog = this.showMarkAsCancelledDialog.bind(this);
		this.hideMarkAsCancelledDialog = this.hideMarkAsCancelledDialog.bind(this);
		this.handleMarkAsPaidDialogConfirm = this.handleMarkAsPaidDialogConfirm.bind(this);
		this.showMarkAsPaidDialog = this.showMarkAsPaidDialog.bind(this);
		this.hideMarkAsPaidDialog = this.hideMarkAsPaidDialog.bind(this);
		this.reloadWorkshopPayment = this.reloadWorkshopPayment.bind(this);
		this.handleSendInvoice = this.handleSendInvoice.bind(this);
		this.showPromoCodeDialog = this.showPromoCodeDialog.bind(this);
		this.hidePromoCodeDialog = this.hidePromoCodeDialog.bind(this);
		this.handlePromoCodeApply = this.handlePromoCodeApply.bind(this);
		this.handleCancelSession = this.handleCancelSession.bind(this);
		this.handleRestoreCancelledSession = this.handleRestoreCancelledSession.bind(this);
		this.handleCancelAllSessions = this.handleCancelAllSessions.bind(this);
		this.hideRefundSessionDialog = this.hideRefundSessionDialog.bind(this);
		this.showRefundSessionDialog = this.showRefundSessionDialog.bind(this);
		this.handleCancellationReasonChange = this.handleCancellationReasonChange.bind(this);
		this.hideRefundAllSessionsDialog = this.hideRefundAllSessionsDialog.bind(this);
		this.showRefundAllSessionsDialog = this.showRefundAllSessionsDialog.bind(this);
		this.handleCancelAndRefundSession = this.handleCancelAndRefundSession.bind(this);
		this.handleCancelAndRefundAllSessions = this.handleCancelAndRefundAllSessions.bind(this);
		this.hideRescheduleDialog = this.hideRescheduleDialog.bind(this);
		this.showRescheduleDialog = this.showRescheduleDialog.bind(this);
		this.handleRescheduleSession = this.handleRescheduleSession.bind(this);
		this.handleRetryInstalment = this.handleRetryInstalment.bind(this);
		this.showMarkAsPaidInstalmentDialog = this.showMarkAsPaidInstalmentDialog.bind(this);
		this.hideMarkAsPaidInstalmentDialog = this.hideMarkAsPaidInstalmentDialog.bind(this);
		this.handleMarkAsPaidInstalmentDialogConfirm = this.handleMarkAsPaidInstalmentDialogConfirm.bind(this);

		this.state = {
			showMarkAsCancelledDialog: false,
			showMarkAsPaidDialog: false,
			showPromoCodeDialog: false,
			showRefundSessionDialog: false,
			showRefundAllSessionsDialog: false,
			cancellationReasonType: null,
			sessionId: null,
			showRescheduleDialog: false,
			showMarkAsPaidInstalmentDialog: false
		};
	}

	componentDidMount() {
		this.reloadWorkshopPayment();
	}

	handleWorkshopPaymentSettingsSubmit(values) {
		const { workshopPayment, updateWorkshopPayment, history } = this.props;

		if (workshopPayment) {
			updateWorkshopPayment(workshopPayment.id, values);
		}
	}

	reloadWorkshopPayment() {
		const { match, fetchWorkshopPayment } = this.props;
		const workshopPaymentId = match.params.id;

		if (workshopPaymentId) {
			fetchWorkshopPayment(workshopPaymentId);
		}
	}

	handleSendInvoice() {
		const { workshopPayment, sendInvoice } = this.props;
		if (workshopPayment) {
			sendInvoice(workshopPayment.id);
		}
	}

	handleMarkAsCancelledDialogConfirm(values) {
		const { workshopPayment, markAsCancelled } = this.props;
		if (workshopPayment) {
			const onSuccessEvent = () => {
				this.reloadWorkshopPayment();
				this.hideMarkAsCancelledDialog();
			}
			markAsCancelled(workshopPayment.id, values, onSuccessEvent);
		}
	}

	showMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: true
		});
	}

	hideMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: false
		});
	}

	handleMarkAsPaidDialogConfirm(values) {
		const { workshopPayment, markAsPaid } = this.props;

		if (workshopPayment) {
			const onSuccessEvent = () => {
				this.reloadWorkshopPayment();
				this.hideMarkAsPaidDialog();
			}
			markAsPaid(workshopPayment.id, values, onSuccessEvent);
		}
	}

	showMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: true
		});
	}

	hideMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: false
		});
	}

	showPromoCodeDialog() {
		this.setState({
			showPromoCodeDialog: true
		});
	}

	hidePromoCodeDialog() {
		this.setState({
			showPromoCodeDialog: false
		});
	}

	handlePromoCodeApply(values) {
		const { workshopPayment, applyPromoCode } = this.props;
		if (workshopPayment) {
			applyPromoCode(workshopPayment.id, values.promoCode,
				() => {
					this.hidePromoCodeDialog();
					this.reloadWorkshopPayment();
				})
		}
	}

	handleCancelSession(sessionId) {
		const { cancelSession } = this.props;
		const onSuccessEvent = () => this.reloadWorkshopPayment();
		cancelSession(sessionId, onSuccessEvent);
	}

	handleRestoreCancelledSession(sessionId) {
		const { restoreCancelledSession } = this.props;
		const onSuccessEvent = () => this.reloadWorkshopPayment();
		restoreCancelledSession(sessionId, onSuccessEvent);
	}

	handleCancelAllSessions() {
		const { cancelAllSessions, workshopPaymentId } = this.props;
		const onSuccessEvent = () => this.reloadWorkshopPayment();
		cancelAllSessions(workshopPaymentId, onSuccessEvent);
	}

	handleCancellationReasonChange(event, cancellationReasonType) {
		this.setState({ cancellationReasonType });
	}

	hideRefundSessionDialog() {
		this.setState({ showRefundSessionDialog: false, sessionId: null, sessionDate: null, cancellationReasonType: null });
	}

	showRefundSessionDialog(sessionId, sessionDate) {
		this.setState({ showRefundSessionDialog: true, sessionId, sessionDate });
	}

	hideRefundAllSessionsDialog() {
		this.setState({ showRefundAllSessionsDialog: false, cancellationReasonType: null });
	}

	showRefundAllSessionsDialog() {
		this.setState({ showRefundAllSessionsDialog: true });
	}

	handleCancelAndRefundSession(options) {
		const { cancelAndRefundSession } = this.props;
		const onSuccessEvent = () => {
			this.hideRefundSessionDialog();
			this.reloadWorkshopPayment();
		};
		cancelAndRefundSession(this.state.sessionId, options, onSuccessEvent);
	}

	handleCancelAndRefundAllSessions(options) {
		const { cancelAndRefundAllSessions, workshopPaymentId } = this.props;
		const onSuccessEvent = () => {
			this.hideRefundAllSessionsDialog();
			this.reloadWorkshopPayment();
		};
		cancelAndRefundAllSessions(workshopPaymentId, options, onSuccessEvent);
	}

	handleRescheduleSession(options) {
		const { rescheduleSession } = this.props;

		const onSuccessEvent = () => {
			this.hideRescheduleDialog();
			this.reloadWorkshopPayment();
		};
		rescheduleSession(this.state.sessionId, options.newSessionId, onSuccessEvent);
	}

	showRescheduleDialog(sessionId, sessionDate, startTime, endTime, type, workshopSessionId) {
		this.props.loadWorkshopSessions(this.props.workshopPayment.workshopId,
			this.setState({ showRescheduleDialog: true, sessionId, sessionDate, startTime, endTime, type, workshopSessionId }))
	}

	hideRescheduleDialog() {
		this.setState({
			showRescheduleDialog: false, sessionId: null, sessionDate: null, startTime: null, endTime: null, type: null, workshopSessionId: null
		});
	}

	handleRetryInstalment(instalmentPaymentId) {
		const { workshopPayment, retryInstalment } = this.props;
		if (workshopPayment) {
			retryInstalment(workshopPayment.id, instalmentPaymentId, this.reloadWorkshopPayment);
		}
	}

	handleMarkAsPaidInstalmentDialogConfirm(values) {
		const { markAsPaidInstalment } = this.props;
		var instalment = this.state.instalment;
		if (instalment) {
			markAsPaidInstalment(instalment.id, values,
				() => {
					this.hideMarkAsPaidInstalmentDialog();
					this.reloadWorkshopPayment();
				});
		}
	}

	showMarkAsPaidInstalmentDialog(instalment) {
		this.setState({
			showMarkAsPaidInstalmentDialog: true,
			instalment
		});
	}

	hideMarkAsPaidInstalmentDialog() {
		this.setState({
			showMarkAsPaidInstalmentDialog: false
		});
	}

	render() {
		const { workshopPayment, canMarkAsPaid, canCancel, isReadonly,
			canUploadInvoice, canSendInvoice, showPaymentOptions, canApplyPromoCode, newPromoCode,
			canCancelSession, cancellationReasonTypes, canRetryInstalment, t } = this.props;

		if (workshopPayment) {
			const sameTypeFutureSessions = this.props.workshopSessions.filter(s => s.isInTheFuture && s.id !== this.state.workshopSessionId &&
				(this.state.type === 'FullDay' ? s.type === 'FullDay' : s.type !== 'FullDay')).sort((a, b) => a.date > b.date ? 1 : -1)
			return (
				<div>
					<MarkAsPaidDialog show={this.state.showMarkAsPaidDialog}
						showPaymentOptions={showPaymentOptions}
						enableManualInstalment={false}
						block={PAYMENT_HISTORY_MARK_AS_PAID_REQUEST}
						unblock={[PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS, PAYMENT_HISTORY_MARK_AS_PAID_FAILURE]}
						onConfirm={this.handleMarkAsPaidDialogConfirm}
						onCancel={this.hideMarkAsPaidDialog} />
					<MarkAsCancelledDialog show={this.state.showMarkAsCancelledDialog}
						block={PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST}
						unblock={[PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE]}
						onConfirm={this.handleMarkAsCancelledDialogConfirm}
						onCancel={this.hideMarkAsCancelledDialog}
						outstandingTotal={workshopPayment.outstandingTotal}
						paymentMethod={workshopPayment.paymentMethod && workshopPayment.paymentMethod.name}
						showWarning={workshopPayment.isInstalmentPayment && (workshopPayment.status.id === 2 || workshopPayment.status.id === 6)}
						removesFrom={workshopPayment.isInstalmentPayment && workshopPayment.status.id === 2 ? 'sessions' : null}
					/>
					<PromoCodeDialog show={this.state.showPromoCodeDialog}
						block={PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST}
						unblock={[PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS, PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE]}
						onConfirm={this.handlePromoCodeApply}
						onCancel={this.hidePromoCodeDialog}
						newPromoCode={newPromoCode} />
					<RefundDialog bsSize='large' show={this.state.showRefundSessionDialog}
						title={t('WorkshopPayment_CancelAndRefundSessionConfirmationTitle')}
						buttonLabel={t('ChildSession_CancellationAndRefund')}
						onCancel={this.hideRefundSessionDialog}
						onConfirm={this.handleCancelAndRefundSession}
						cancellationReasonTypes={cancellationReasonTypes}
						initialValues={{ lessonDate: this.state.sessionDate }}
						onReasonChange={this.handleCancellationReasonChange}
						cancellationReasonType={this.state.cancellationReasonType}
					/>
					<RefundDialog bsSize='large' show={this.state.showRefundAllSessionsDialog}
						title={t('WorkshopPayment_CancelAndRefundAllSessionsConfirmationTitle')}
						buttonLabel={t('WorkshopPayment_CancelAndRefundAllSessions')}
						onCancel={this.hideRefundAllSessionsDialog}
						onConfirm={this.handleCancelAndRefundAllSessions}
						cancellationReasonTypes={cancellationReasonTypes}
						onReasonChange={this.handleCancellationReasonChange}
						cancellationReasonType={this.state.cancellationReasonType}
					/>
					<RescheduleDialog bsSize='large' show={this.state.showRescheduleDialog}
						onCancel={this.hideRescheduleDialog}
						onConfirm={this.handleRescheduleSession}
						workshopSessions={sameTypeFutureSessions}
						initialValues={{sessionDate: this.state.sessionDate, startTime: this.state.startTime, endTime: this.state.endTime }}
					/>
					<MarkAsPaidInstalmentDialog show={this.state.showMarkAsPaidInstalmentDialog}
						block={INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST}
						unblock={[INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE]}
						onConfirm={this.handleMarkAsPaidInstalmentDialogConfirm}
						onCancel={this.hideMarkAsPaidInstalmentDialog} />
					<WorkshopPaymentSettingsForm
						isReadonly={isReadonly}
						onSubmit={this.handleWorkshopPaymentSettingsSubmit}
						initialValues={workshopPayment}
						payment={workshopPayment}
						canMarkAsPaid={canMarkAsPaid}
						canCancel={canCancel}
						markAsPaid={this.showMarkAsPaidDialog}
						markAsCancelled={this.showMarkAsCancelledDialog}
						canUploadInvoice={canUploadInvoice}
						canSendInvoice={canSendInvoice}
						sendInvoice={this.handleSendInvoice}
						canApplyPromoCode={canApplyPromoCode}
						onApplyPromoCode={this.showPromoCodeDialog}
						canCancelSession={canCancelSession}
						cancelSession={this.handleCancelSession}
						restoreCancelledSession={this.handleRestoreCancelledSession}
						cancelAllSessions={this.handleCancelAllSessions}
						cancelAndRefundSession={this.showRefundSessionDialog}
						cancelAndRefundAllSessions={this.showRefundAllSessionsDialog}
						rescheduleSession={this.showRescheduleDialog}
						canRetryInstalment={canRetryInstalment}
						retryInstalment={this.handleRetryInstalment}
						onRefresh={this.reloadWorkshopPayment}
						markInstalmentAsPaid={this.showMarkAsPaidInstalmentDialog}
						canMarkInstalmentAsPaid={this.props.canMarkInstalmentAsPaid}
					/>
				</div>
			);
		}
		return null;
	}
}

const mapStateToProps = (state, ownProps) => {
	const workshopPaymentId = ownProps.match.params.id;

	const {
		entities: { workshopPayments, workshopSessions },
		lookups: { cancellationReasonTypes },
		filters: { workshopSessionsByWorkshop },
		auth: { currentUser }
	} = state;

	const workshopPayment = workshopPayments[workshopPaymentId];

	let canMarkAsPaid, canCancel, canUploadInvoice, canSendInvoice, canApplyPromoCode, showPaymentOptions,
		canCancelSession, sessions;
	if (workshopPayment) {
		canMarkAsPaid = workshopPayment.canMarkAsPaid && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canCancel = workshopPayment.canCancel && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canUploadInvoice = authUtils.hasPermission(currentUser, 'UploadInvoice');
		canSendInvoice = authUtils.hasPermission(currentUser, 'MarkAsPaid') && workshopPayment.status.id === 2 && workshopPayment.total > 0;
		canApplyPromoCode = workshopPayment.canApplyPromoCode && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		showPaymentOptions = workshopPayment.showPaymentOptions;
		canCancelSession = authUtils.hasPermission(currentUser, 'CancelChildLesson');
		const workshopSessionsByWorkshopFilter = workshopSessionsByWorkshop[workshopPayment.workshopId] || { ids: [] };
		sessions = workshopSessionsByWorkshopFilter.ids.map(workshopId => workshopSessions[workshopId]);
	}

	return {
		workshopPayment,
		workshopPaymentId,
		canMarkAsPaid,
		canCancel,
		canUploadInvoice,
		canSendInvoice,
		cancellationReasonTypes,
		canApplyPromoCode,
		canRetryInstalment: authUtils.hasPermission(currentUser, 'MarkAsPaid'),
		showPaymentOptions,
		newPromoCode: promoCodeFormSelector(state, 'promoCode'),
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WorkshopPayments'),
		canCancelSession,
		workshopSessions: sessions,
		canMarkInstalmentAsPaid: authUtils.hasPermission(currentUser, 'MarkInstalmentAsPaid')
	};
};

export default connect(mapStateToProps, {
	fetchWorkshopPayment,
	updateWorkshopPayment,
	markAsPaid,
	markAsCancelled,
	sendInvoice,
	applyPromoCode,
	cancelSession,
	restoreCancelledSession,
	cancelAllSessions,
	cancelAndRefundSession,
	cancelAndRefundAllSessions,
	rescheduleSession,
	loadWorkshopSessions,
	retryInstalment,
	markAsPaidInstalment
})(withTranslation()(Details));